module.exports = __webpack_public_path__ + "img/32.69795de2.webp";